/**
 * DocumentDeployIcon — stacked papers with a fold corner.
 * Phase: document-deploy.
 */

import type { ReactNode } from 'react';

interface IconProps {
  readonly size?: number;
  readonly color?: string;
}

export function DocumentDeployIcon({ size = 18, color = '#F4EFE2' }: IconProps): ReactNode {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M5 6.5h9.5l3.5 3.5v10H5z" />
      <path d="M14.5 6.5v3.5H18" />
      <path d="M8.5 14.5h6" />
      <path d="M8.5 17h4" />
    </svg>
  );
}
